import styled from "styled-components";

export const ProviderLogo = styled.img`
    width: 150px;
    justify-self: center;
`